const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const uploadApiUrl = process.env.NEXT_PUBLIC_UPLOAD_API_URL;

/**
 * @feBot
 */
// 前端机器人上报
export const feBotEndpoint = `${apiUrl}/internal/v1/fe_report`;

/**
 * @用户
 */
// 匿名用户初始化
export const initUserEndpoint = `${apiUrl}/users/v1/init_me`;
// 初始化用户资产
export const initUserAssetsEndpoint = `${apiUrl}/users/v1/me`;
// 发送验证码
export const sendCodeEndpoint = `${apiUrl}/users/v1/send_code`;
// 校验验证码
export const verifyCodeEndpoint = `${apiUrl}/users/v1/verify_code`;
// 获取 custom_token
export const getCustomTokenEndpoint = `${apiUrl}/users/v1/create_custom_user`;
// 设置邮箱通知
export const setEmailNotifyEndpoint = `${apiUrl}/users/v1/set_email_notify`;
// 获取用户历史记录
export const getUserHistoryEndpoint = `${apiUrl}/users/v1/user_history`;

/**
 * @资产
 */
// 消费购买
export const createSubscriptionEndpoint = `${apiUrl}/users/v1/subscribe`;
// 取消订阅
export const unsubscribeEndpoint = `${apiUrl}/users/v1/unsubscribe`;
// 更新用户资产
export const updateDownloadEndpoint = `${apiUrl}/users/v1/update_download`;

/**
 * @上传图像
 */
export const uploadFileEndpoint = `${uploadApiUrl}/comm_api/file/v1/upload_file`;
export const batchGetUploadUrlEndpoint = `${uploadApiUrl}/comm_api/file/v1/batch_get_upload_url`;

/**
 * @批量任务 - 通用接口
 */
// 获取批量任务结果
export const getBatchRMWResultEndpoint = `${apiUrl}/toolkit/v1/get_task_result`;

/**
 * @去水印
 */
// export const watermarkRemovalEndpoint = `${apiUrl}/toolkit/v1/watermark_removal`;
// export const watermarkRemovalEndpointV2 = `${apiUrl}/toolkit/v2/watermark_removal`;
// 批量去水印接口
export const batchWatermarkRemovalEndpoint = `${apiUrl}/toolkit/v1/batch_watermark_removal`;

/**
 * @图像修复
 */
// 批量图像修复
export const batchRepairImageEndpoint = `${apiUrl}/toolkit/v1/batch_restoration`;
// 单个图像修复
// export const repairImageEndpoint = `${apiUrl}/toolkit/v1/restoration`;

/**
 * @背景去除
 */
// 单个背景去除
// export const backgroundRemoverEndpoint = `${apiUrl}/toolkit/v1/background_removal`;
// 批量背景去除
export const batchBackgroundRemoverEndpoint = `${apiUrl}/toolkit/v1/batch_background_removal`;

/**
 * @AI证件照
 */
// 去生成证件照
export const aiHeadshotsEndpoint = `${apiUrl}/toolkit/v1/submit_id_photo`;
// 获取任务列表
export const getTaskListEndpoint = `${apiUrl}/toolkit/v1/get_id_photo_list`;
// 获取任务结果
export const getTaskResultEndpoint = `${apiUrl}/toolkit/v1/get_id_photo_result`;
// 检测图像是否符合证件照预期
export const checkIdPhotoEndpoint = `${apiUrl}/toolkit/v1/check_id_photo`;
// 检测用户资产是否足够使用
export const checkQuotaEndpoint = `${apiUrl}/toolkit/v1/check_quota`;
export const userFeedbackEndpoint = `${apiUrl}/toolkit/v1/user_feedback`;

/**
 * @ads
 */
export const tiktokAdsEndpoint = `${apiUrl}/ads/v1/tiktok_conversion`;
export const metaAdsEndpoint = `${apiUrl}/ads/v1/meta_conversion`;

/**
 * @promote
 */
// 邀请码生成
export const generateInviteCodeEndpoint = `${apiUrl}/users/v1/generate_invite_code`;

/**
 * @stripe
 */
export const getStripePaymentEndpoint = `${apiUrl}/payment/v1/get_stripe_payment`;

/**
 * @headshot
 */
export const reportIdPhotoDownloadEndpoint = `${apiUrl}/users/v1/report_id_photo_download`;
export const PhotoNotifySmsEndpoint = `${apiUrl}/toolkit/v1/id_photo_sms_notify`;

/**
 * @ai-expand
 */
export const aiExpandEndpoint = `${apiUrl}/toolkit/v1/expansion`;

/**
 * @API
 */
// 创建API Token
export const createApiTokenEndpoint = `${apiUrl}/users/v1/create_api_token`;
// 获取API Token
export const getApiTokenEndpoint = `${apiUrl}/users/v1/get_api_token`;
// 删除API Token
export const deleteApiTokenEndpoint = `${apiUrl}/users/v1/delete_api_token`;
// 获取API Token使用情况
export const getApiTokenUsageEndpoint = `${apiUrl}/users/v1/get_api_token_usage`;

/**
 * @联系我们服务
 */
// 联系我们 - 发送邮件（不带附件）
export const contactUsEndpoint = `${apiUrl}/users/v1/contact_us`;
// 联系我们 - 发送邮件（带附件）
export const contactUsWithAttachmentEndpoint = `${apiUrl}/users/v1/contact_us`;
